// extracted by mini-css-extract-plugin
export default {"mainContainer":"Dashboard_mainContainer__AAvs7","mainView":"Dashboard_mainView__hSvYG"};